"use client";

import React from 'react';
import { Flame, Wind, Fan } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from '@/components/common/Link';
import { useRevealOnScroll } from '@/hooks/useRevealOnScroll';
const features = [{
  title: "Riduzione Rischio Incendio",
  description: "I depositi di grasso all'interno dei condotti sono altamente infiammabili. La rimozione profonda elimina il combustibile principale, prevenendo inneschi e propagazione delle fiamme.",
  icon: Flame
}, {
  title: "Efficienza di Aspirazione",
  description: "L'accumulo di residui riduce la sezione utile del tubo e crea attrito. La bonifica ripristina i volumi d'aria originali, migliorando l'estrazione di fumi e odori.",
  icon: Wind
}, {
  title: "Longevità dei Ventilatori",
  description: "Il grasso sulle pale sbilancia le giranti e sovraccarica i motori. Un impianto bonificato riduce le vibrazioni, i consumi elettrici e previene guasti improvvisi.",
  icon: Fan
}];
export default function SafetyEfficiencyGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="safetyefficiencygrid" className="bg-background">
      <div className="bg-primary relative py-24 overflow-hidden">
        {}
        <svg className="absolute inset-0 w-full h-full opacity-[0.04] pointer-events-none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <defs>
            <pattern id="schematic-grid" width="64" height="64" patternUnits="userSpaceOnUse">
              <path d="M 64 0 L 0 0 0 64" fill="none" stroke="currentColor" strokeWidth="1" />
              <circle cx="64" cy="64" r="1.5" fill="currentColor" />
              <circle cx="0" cy="0" r="1.5" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#schematic-grid)" className="text-primary-foreground" />
        </svg>

        <div className="container mx-auto px-6 relative z-10">
          <div ref={ref} className={`transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <h2 className="text-center text-4xl md:text-5xl font-default font-semibold text-primary-foreground mb-16 tracking-tight">
              Sicurezza ed efficienza dell'impianto
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
              {features.map((feature, i) => {
              const Icon = feature.icon;
              return <div key={i} data-index={i} className="md:col-span-4 relative border border-primary-foreground/15 bg-primary p-8 group hover:bg-primary-foreground/5 transition-colors duration-300">
                    {}
                    <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-accent transition-all duration-300 group-hover:w-6 group-hover:h-6" aria-hidden="true" />
                    <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-accent transition-all duration-300 group-hover:w-6 group-hover:h-6" aria-hidden="true" />
                    <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-accent transition-all duration-300 group-hover:w-6 group-hover:h-6" aria-hidden="true" />
                    <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-accent transition-all duration-300 group-hover:w-6 group-hover:h-6" aria-hidden="true" />

                    <Icon className="w-8 h-8 text-accent mb-6 stroke-[1.5]" aria-hidden="true" />
                    
                    <h3 className="text-xl font-default font-medium text-primary-foreground mb-4">
                      {feature.title}
                    </h3>
                    
                    <p className="text-base font-sans text-primary-foreground/80 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>;
            })}
            </div>

            {}
            <div className="mt-24 max-w-3xl mx-auto text-center border-t border-primary-foreground/10 pt-16">
              <h3 className="text-2xl md:text-3xl font-default font-medium text-primary-foreground mb-6">
                Vuoi sapere cosa c'è davvero dentro i tubi della tua cappa?
              </h3>
              <p className="text-base md:text-lg font-sans text-primary-foreground/80 mb-10">
                Aera esegue sopralluoghi tecnici su cappe professionali e tubazioni di estrazione cucina, con ispezione, intervento interno e documentazione finale.
              </p>
              <Button asChild size="lg" className="bg-accent text-white hover:bg-accent/90 border-none">
                <Link to="/TechnicalInspectionPage">Richiedi sopralluogo tecnico</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}